import { postIssueFreespin } from '../api/postIssueFreespin';

const setPostIssueFrespin = (params) => {
    return async (dispatch, getState) => {
        try {
            await postIssueFreespin(params);
            alert('Фриспин создан')
        } catch(error) {
            alert('Ошибка создания')
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostIssueFrespin
}